export enum SortDirection {
    None,
    Asce,
    Desc
  }